/**
 * @Description
 */

import { FC } from 'react';
import styles from './index.module.less';
import cs from 'classnames';

const LastPage:FC<any> = ({ qrCode }) => {
  const card = [
    { name: '商业场地', count: '8000+', bg: 'commercial' },
    { name: '发布需求', count: '3000+', bg: 'requirement' },
    { name: '累计沟通', count: '50W+', bg: 'contact' },
  ];
  return (
    <div className={styles['page']}>
      <div className={styles['left']}>
        <div className={styles['content']}>
          <div className={styles['title']}>LOCATION商业直租</div>

          <div className={styles['box']}>
            {card.map((item, index) => {
              return (
                <div className={cs(styles['card'], styles[`${item.bg}`])} key={index}>
                  <div className={styles['card-name']}>{item.name}</div>
                  <div className={styles['card-count']}>{item.count}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className={styles['right']}>
        <div className={styles['content']}>
          <img src={qrCode} className={styles['code']}/>

          <div className={styles['name']}>扫码开始市场调研</div>

          <div className={styles['tips']}>不止市场调研，还有空铺信息实时更新～</div>
        </div>
      </div>
    </div>
  );
};

export default LastPage;
